import { LocationState } from "stores/wizard/state/global/location";

export const locationState = (): LocationState => {
  return {
    origin: {
      value: "",
      metaData: {
        regionId: "",
        ttla: "",
        latLong: "",
        countryCode: ""
      }
    },
    destination: {
      value: "",
      metaData: {
        regionId: "",
        ttla: "",
        latLong: "",
        countryCode: ""
      }
    }
  };
};
